import { ErrorResponse } from "../../../utils";
import { State } from "./state";
import { COMMANDS } from "../../../shared";
import { Action as TAction, StoreDispatchProps } from "../../../Store";
import { Dispatch } from "redux";
import { actionCreator } from "../../../ajax";
import { Omit } from "../../../utils";

export namespace Actions {
  // ACTION TYPES
  export const REQUEST_GET = "io/request/linq8acm/timers/get";
  export const RESPONSE_GET = "io/response/linq8acm/timers/get";
  export const REQUEST_EDIT = "io/request/linq8acm/timers/edit";
  export const RESPONSE_EDIT = "io/response/linq8acm/timers/edit";
  export const RESPONSE_EDIT_END = "io/response/linq8acm/timers/edit/end";
  export const REQUEST_ADD = "io/request/linq8acm/timers/add";
  export const RESPONSE_ADD = "io/response/linq8acm/timers/add";
  export const REQUEST_DELETE = "io/request/linq8acm/timers/delete";
  export const RESPONSE_DELETE = "io/response/linq8acm/timers/delete";
  export const EDIT_TIMERS = "io/edit/timers/linq8acm/timers";
  export const EDIT_TIMERS_COMMANDS = "io/edit/timers/commands/linq8acm/timers";
  export const EDIT_NEW = "io/edit/new/linq8acm/timers";
  export const EDIT_NEW_COMMANDS = "io/edit/new/commands/linq8acm/timers";

  // ACTION INTERFACES
  export interface GetRequest extends TAction<typeof REQUEST_GET> {}
  export interface EditRequest extends TAction<typeof REQUEST_EDIT> {
    data: Partial<State.Data>;
    post?: State.ServerRequest;
  }
  export interface GetResponse extends TAction<typeof RESPONSE_GET> {
    data: State.ServerResponse;
  }
  export interface EditResponse extends TAction<typeof RESPONSE_EDIT> {
    data: ErrorResponse;
  }
  export interface EditResponseEnd extends TAction<typeof RESPONSE_EDIT_END> {}
  export interface AddRequest extends TAction<typeof REQUEST_ADD> {
    data: State.Timer;
    post?: State.ServerRequest;
  }
  export interface AddResponse extends TAction<typeof RESPONSE_ADD> {
    data: ErrorResponse;
  }
  export interface DeleteRequest extends TAction<typeof REQUEST_DELETE> {
    data: string;
  }
  export interface DeleteResponse extends TAction<typeof RESPONSE_DELETE> {
    data: ErrorResponse;
  }
  export interface EditTimers extends TAction<typeof EDIT_TIMERS> {
    data: Omit<Partial<State.Timer>, "cmds">;
    idx: number;
  }
  export interface EditTimersCommands
    extends TAction<typeof EDIT_TIMERS_COMMANDS> {
    idx: number;
    output: number;
    url: string;
    cmd: COMMANDS;
  }
  export interface EditAdd extends TAction<typeof EDIT_NEW> {
    data: Omit<Partial<State.Timer>, "cmds">;
  }
  export interface EditAddCommands extends TAction<typeof EDIT_NEW_COMMANDS> {
    output: number;
    url: string;
    cmd: COMMANDS;
  }

  export interface DispatchProps extends StoreDispatchProps<State.Data> {}

  // FORM ACTIONS
  export const editAdd = actionCreator<EditAdd>(EDIT_NEW);
  export const editTimers = actionCreator<EditTimers>(EDIT_TIMERS);
  export const editAddCommands = actionCreator<EditAddCommands>(
    EDIT_NEW_COMMANDS
  );
  export const editTimersCommands = actionCreator<EditTimersCommands>(
    EDIT_TIMERS_COMMANDS
  );

  // SERVER ACTIONS
  export const getRequest = actionCreator<GetRequest>(REQUEST_GET);
  export const getResponse = actionCreator<GetResponse>(RESPONSE_GET);
  export const editRequest = actionCreator<EditRequest>(REQUEST_EDIT);
  export const editResponse = actionCreator<EditResponse>(RESPONSE_EDIT);
  export const editResponseEnd = actionCreator<EditResponseEnd>(
    RESPONSE_EDIT_END
  );
  export const addRequest = actionCreator<AddRequest>(REQUEST_ADD);
  export const addResponse = actionCreator<AddResponse>(RESPONSE_ADD);
  export const deleteRequest = actionCreator<DeleteRequest>(REQUEST_DELETE);
  export const deleteResponse = actionCreator<DeleteResponse>(RESPONSE_DELETE);

  export const bindDispatchProps = (dispatch: Dispatch) => {
    return {
      editTimers: (idx: number, data: Partial<State.Timer>) =>
        dispatch(editTimers({ data, idx })),
      editTimersCommands: (
        idx: number,
        url: string,
        output: number,
        cmd: COMMANDS
      ) => dispatch(editTimersCommands({ idx, output, url, cmd })),
      editAdd: (data: Partial<State.Timer>) => dispatch(editAdd({ data })),
      editAddCommands: (url: string, output: number, cmd: COMMANDS) =>
        dispatch(editAddCommands({ output, url, cmd })),
      fetch: () => dispatch(getRequest()),
      update: (data: Partial<State.Data>) => dispatch(editRequest({ data })),
      add: (data: State.Timer) => dispatch(addRequest({ data })),
      remove: (data: string) => dispatch(deleteRequest({ data }))
    };
  };
}
